// extracted by mini-css-extract-plugin
export var fileUpload = "_dg-1";
export var modalButton = "_dg-0";